import React from "react";

import styles from "./TableLoader.module.css";

export const TableLoader: React.FC = () => {
    return <div className={styles.wrapper}>
        <span className={styles.text}>Loading</span>
        <div className={styles.loader}/>
    </div>
}
